












import Vue from "vue"
import WideStaticNotice from "~/components/guideline/notice/WideStaticNotice.vue"

export default Vue.extend({
  components: {
    WideStaticNotice,
  },
  props: {
    alertText: {
      type: String,
      required: true,
    },
    buttonText: {
      type: String,
      required: true,
    },
  },
  methods: {
    openSignupPage() {
      window.location.href = `${process.env.FRONTEND_WORKER_BASE_URL}/worker/signup/`
    },
  },
})
